import React,{useEffect,useState} from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import Services from '../Pages/ArtprintsLandscape';
import CategoryNavigation from '../Components/CategoryNavigation';


const images = [
  'https://vizaura.s3.eu-north-1.amazonaws.com/ArtPrints/banners/Landscape/1.jpg',
  'https://vizaura.s3.eu-north-1.amazonaws.com/ArtPrints/banners/Landscape/2.jpg',
  'https://vizaura.s3.eu-north-1.amazonaws.com/ArtPrints/banners/Landscape/3.jpg',
  'https://vizaura.s3.eu-north-1.amazonaws.com/ArtPrints/banners/Landscape/4.jpg',
  'https://vizaura.s3.eu-north-1.amazonaws.com/ArtPrints/banners/Landscape/5.jpg'
];

const ArtprintsLandscape = () => {
useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [loading, setLoading] = useState(true); 
  const [imageUrls, setImageUrls] = useState([]);

  
  useEffect(() => {
    const loadedImages = [];
    let imagesLoadedCount = 0;

    const handleImageLoad = (img) => {
      imagesLoadedCount++;
      if (imagesLoadedCount === images.length) {
        setLoading(false);
      }
    };

    images.forEach((src, index) => {
      const img = new Image();
      img.src = src;
      
      img.onload = () => {
        loadedImages[index] = src;
        handleImageLoad(img);
      };

      img.onerror = () => {
        const jpegUrl = src.replace('.jpg', '.jpeg');
        const jpegImg = new Image();
        jpegImg.src = jpegUrl;
        
        jpegImg.onload = () => {
          loadedImages[index] = jpegUrl;
          handleImageLoad(jpegImg);
        };
        
        jpegImg.onerror = () => {
          console.error(`Failed to load image at index ${index} from both .jpg and .jpeg sources.`);
          loadedImages[index] = ''; 
          handleImageLoad(jpegImg);
        };
      };
    });

    setImageUrls(loadedImages);

    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 1500); 
    return () => clearInterval(interval); 
  }, []);

  return (
    <div>
      <Navbar />
      <div className='mt-20 flex flex-col md:flex-row justify-center items-center gap-10 md:gap-14 pt-5 pb-20 md:pb-0 px-4' id='our'>
        <div className='w-full md:w-[50%] max-w-[620px] flex justify-center items-center'>
          {loading ? (
            <div className="aspect-square w-full max-w-[380px] rounded-xl bg-gray-200 animate-pulse flex items-center justify-center">
             
            </div>
          ) : (
            <div className="relative aspect-square w-full max-w-[380px] rounded-xl overflow-hidden">
              {imageUrls.map((src, index) => (
                <img
                  key={index}
                  src={src}
                  alt="Wallpaper"
                  className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ease-in-out ${
                    index === currentImageIndex ? 'opacity-100' : 'opacity-0'
                  }`}
                />
              ))}
            </div>
          )}
        </div>
  <div className='w-full md:w-[50%] max-w-[650px] text-center md:text-left'>
    <h2 className='text-2xl sm:text-3xl md:text-4xl font-serif leading-snug'>
      Landscape art brings the beauty of the outdoors into your space. 
    </h2>
    <CategoryNavigation type="artprints" currentLink="/artprints/landscape" />
  </div>
</div>

 <Services />
 <div className='pb-10'></div>
 <Footer />
</div>
  )
}

export default ArtprintsLandscape;